export var SIZE_OPTIONS = {
  SMALL: "small",
  NORMAL: "normal"
};
export var RESIZE_OPTIONS = {
  VERTICAL: "vertical",
  NONE: "none"
};